// extracted by mini-css-extract-plugin
export default {"btn":"GeneratePasswordBtn_btn__EqVOQ","arrowIcon":"GeneratePasswordBtn_arrowIcon__0OoOP"};